import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../common/api';
import { APIEndPoints } from '../common/endPoint';

export const getListWebJobs = createAsyncThunk(
    'getListWebJobs',
    async ({ pageParam = 1, size = 10, search }) => {
  
      const obj = {
        url: `${APIEndPoints.JobsAPI}/list?page=${pageParam}&page_size=${size}&query=${search ? search : ''}`,
        method: 'GET',
      };
      return await API(obj);
    }
  );

export const getListWebReportedJobs = createAsyncThunk(
    'getListWebReportedJobs',
    async ({ pageParam = 1, size = 10, search }) => {
  
      const obj = {
        url: `${APIEndPoints.ReportAPI}/job/list?page=${pageParam}&page_size=${size}&query=${search ? search : ''}`,
        method: 'GET',
      };
      return await API(obj);
    }
  );

  export const updateJobsStatus = createAsyncThunk(
    'updateJobsStatus',
    async (body) => {
      const obj = {
        url: `${APIEndPoints.JobsAPI}/list`,
        method: 'PUT',
        body:JSON.stringify(body)
      };
      return await API(obj);
    }
  );


  